exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n[data-v-88cbfab8] .el-carousel__arrow{width:60px !important;height:60px !important;font-size:34px !important;color:#009f61\n}\n", "", {"version":3,"sources":["/app/src/components(new)/UI/Modals/VisualizarDocumentos/VisualizarDocumentos.vue","/app/src/components(new)/UI/Modals/VisualizarDocumentos/styles.scss"],"names":[],"mappings":";AAAA,sCCCE,sBACA,uBACA,0BACA,aAAc;CACf","file":"VisualizarDocumentos.vue","sourcesContent":[">>>.el-carousel__arrow{width:60px !important;height:60px !important;font-size:34px !important;color:#009f61}\n",">>> .el-carousel__arrow {\n  width: 60px !important;\n  height: 60px !important;\n  font-size: 34px !important;\n  color: #009f61;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-88cbfab8","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components(new)/UI/Modals/VisualizarDocumentos/VisualizarDocumentos.vue
// module id = C5BY
// module chunks = 5